import appDataReducers from '@repo/redux/reducers/data';
import appSharedDataReducers from '@repo/redux/reducers/sharedData';
import appUIReducers from '@repo/redux/reducers/ui';
import appUserReducers from '@repo/redux/reducers/user';
import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  data: combineReducers(appDataReducers),
  sharedData: combineReducers(appSharedDataReducers),
  ui: combineReducers(appUIReducers),
  user: combineReducers(appUserReducers),
});

export default rootReducer;
